
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/brevo",
      function () {
        return require("private-next-pages/destinations/brevo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/brevo"])
      });
    }
  